import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { urlServer } from '../global_constants';
import { ServiceResponse } from '../models/service-response';
@Injectable({
  providedIn: 'root'
})
export class UserService {

  public get userRole() : string|null {
    if(localStorage.getItem("role")!=null && localStorage.getItem("role")!=undefined) 
    return localStorage.getItem("role");
    return sessionStorage.getItem("role");
  }
  constructor(private httpClient:HttpClient) {
    this.loginSubject=new Subject();
    this.userSubject=new Subject();
    this.passSubject=new Subject();
    this.profilSubject=new Subject();
    this.infoSubject=new Subject();
    this.companySubject= new Subject();
    this.retiereveInvoiceSubject= new Subject();
    this.addInvoiceSubject= new Subject();
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
      this.token = localStorage.getItem("token")
    else this.token = sessionStorage.getItem("token")
  }
   token:any;
  //LOGIN variables
  pathApi:string="/v1/signin";
  loginSubject:Subject<any>;
  loginRequest:any;
  urlRequestSignin: string =urlServer.concat(this.pathApi);
  //USER variables
  pathApiuser:string="/v1/user";
  userSubject:Subject<any>;
  userRequest:any;
  urlRequestUser: string =urlServer.concat(this.pathApiuser);

  //PROFILE variables
  pathApiprofil:string="/v1/user/profile";
  profilSubject:Subject<any>;
  profilRequest:any;
  urlRequestProfil: string =urlServer.concat(this.pathApiprofil);

  //PassModify variables
  pathApipass:string="/v1/user/confidentiality";
  passSubject:Subject<any>;
  passRequest:any;
  urlRequestPass: string =urlServer.concat(this.pathApipass);

  //InfoModify variables
  pathApiinfo:string="/v1/user";
  infoSubject:Subject<any>;
  infoRequest:any;
  urlRequestInfo: string =urlServer.concat(this.pathApiinfo);

  //EntrepriseModify variables
  pathApicompany:string="/v1/user/";
  companySubject:Subject<any>;
  companyRequest:any;
  urlRequestCompany: string =urlServer.concat(this.pathApiinfo);
  pathApiCompanyUsers:string="/v1/users";
  urlRequestCompanyUsers: string =urlServer.concat(this.pathApiCompanyUsers);

  //Version variables
  pathApiversion:string="/v1/version";
  versionSubject!:Subject<any>;
  versionRequest:any;
  urlRequestVersion: string =urlServer.concat(this.pathApiversion);

  pathApiRetiereveInvoice:string="/v1/invoiceDetail";
  retiereveInvoiceSubject!:Subject<any>;
  urlRequestRetiereveInvoice: string = urlServer.concat(this.pathApiRetiereveInvoice);

  pathApiAddInvoice:string="/v1/newInvoice";
  addInvoiceSubject!:Subject<any>;
  urlRequestAddInvoice: string = urlServer.concat(this.pathApiAddInvoice);

  getUserFilteredData(uuid: string, filters: string[]): Observable<any> {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    const url = `${this.urlRequestInfo}/${uuid}?filter=${filters.join(',')}`;
    return this.httpClient.get<any>(url,{headers: header});
  }

  getCompanyInvoice(){
    this.retiereveInvoiceSubject= new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    this.httpClient.get<ServiceResponse>(this.urlRequestRetiereveInvoice,{headers: header}).subscribe(
      (response: any) => {
        this.retiereveInvoiceSubject.next(response);
        this.retiereveInvoiceSubject.complete();
      },
      (error) => {
        console.error('Error retrieving version:', error);
      }
    );;
  }

  updateInvoice(body :any) {
      this.addInvoiceSubject = new Subject();
      let header: HttpHeaders = new HttpHeaders();
      header = header.set('authorization', "Bearer "+this.token );
      this.httpClient.post(this.urlRequestAddInvoice,body,{headers: header}).subscribe((response: any) => {
          this.addInvoiceSubject.next(response);
          this.addInvoiceSubject.complete();
      },error => {
        console.error('There was an error!', error);
      }
      );
    }
  getVersion(): void {
    this.versionSubject = new Subject();
    const header: HttpHeaders = new HttpHeaders().set('authorization', 'Bearer ' + this.token);
    this.httpClient.get<string>(this.urlRequestVersion, { headers: header }).subscribe(
      (response: string) => {
        this.versionSubject.next(response);
        this.versionSubject.complete();
      },
      (error) => {
        console.error('Error retrieving version:', error);
      }
    );
  }

  getUserInfo(){    
    this.userSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestUser,{headers: header}).subscribe((response: any) => {
        this.userSubject.next(response);
        this.userSubject.complete();
    },
      error => {
      }
    );
  }

  log_user() {
    this.loginSubject = new Subject();
    const body = {
      login: this.loginRequest.login,
      password:this.loginRequest.password
    };
    this.httpClient.post(this.urlRequestSignin,  body/*, httpOptions*/
      ).subscribe((response: any) => {
        this.loginSubject.next(response);
        this.loginSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  getPass() {
    this.passSubject = new Subject();
    const body = {
      older: this.passRequest.older,
      newer:this.passRequest.newer,
      confirmation:this.passRequest.confirmation
    };
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    
    this.httpClient.put(this.urlRequestPass,body,{headers: header}).subscribe((response: any) => {
        this.passSubject.next(response);
        this.passSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
      );
    }

  getProfil(){    
    this.profilSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestProfil,{headers: header}).subscribe((response: any) => {
        this.profilSubject.next(response);
        this.profilSubject.complete();
    },
      error => {
      }
    );
  }
  getInfoupdate() {
    
    this.infoSubject = new Subject();
    this.infoRequest.personal_avatar = this.infoRequest.personal_avatar.split("64,", 2);
    var picture = null;
    if(this.infoRequest.personal_avatar[1]!="undefined"){
      picture = this.infoRequest.personal_avatar[1];
    }
    
    const body = {
      personal_phone: this.infoRequest.personal_phone,
      personal_email:this.infoRequest.personal_email,
      personal_avatar:picture
    };
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    
    this.httpClient.patch(this.urlRequestInfo+"/0be5a6c82893ecaa8bb29bd36831e457",body,{headers: header}).subscribe((response: any) => {
        this.infoSubject.next(response);
        this.infoSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
      );
    } 
    getCompanyupdate() {
      this.companySubject = new Subject();
      this.companyRequest.company_logo = this.companyRequest.company_logo.split("64,", 2);
      const body = {
        company_reason: this.companyRequest.company_reason,
        company_sector:this.companyRequest.company_sector,
        company_phone:this.companyRequest.company_phone,
        company_city:this.companyRequest.company_city,
        company_address:this.companyRequest.company_address,
        company_logo:this.companyRequest.company_logo[1]
      };
      let header: HttpHeaders = new HttpHeaders();
      header = header.set('authorization', "Bearer " + this.token);
      
      this.httpClient.patch(this.urlRequestCompany+"/93c731f1c3a84ef05cd54d044c379eaa",body,{headers: header}).subscribe((response: any) => {
          this.companySubject.next(response);
          this.companySubject.complete();
      },
      error => {
        console.error('There was an error!', error);
      }
      );
    }

    getCompanyUsers(): Observable<ServiceResponse> {
      let header: HttpHeaders = new HttpHeaders();
      header = header.set('authorization', "Bearer " + this.token);
      return this.httpClient.get<ServiceResponse>(this.urlRequestCompanyUsers,{headers: header});
    }

    //helper
    getProfileName(uuid: string) {
      switch (uuid) {
        case "a21aab19-d73e-47db-a61c-d2c1f0c8a251":
          return "Commercial";
        case "d8aeff31-284b-11ed-8482-00163ee67c31":
          return "Assistante commerciale";
        case "981dc265-63b8-45ba-b356-befb5a9a6f74":
          return "Directeur";
      
        default:
          return "--";
      }
    }
}
